const regionAlert = [
    {
        selector: '#page',
        path: { filename: 'regionAlert' },
    },
];

export { regionAlert };
